import { h, Ref } from 'vue';
import { Task, useValidation } from '@/ui/concerns';
import { RegisteringUser, validate } from '@/entities/auth/registeringUser';
import { inputField } from '@/ui/components/form';
import { t } from '@/ui/i18n/i18n';
import { apiErrorMessage } from '@/ui/components';
import { phoneNumberField } from '@/ui/components/form/PhoneNumberField';
import { PhoneNumberUpdateData } from '@/ui/components/form/PhoneNumberInput';

export function useRegisterForm(userRecord: Ref<RegisteringUser>, registerTask: Task, columnsClass: string) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, userRecord, registerTask.state);

  const handleRegisterFormSubmit = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    if (document.querySelector('.maz-base-component.is-focused')) {
      return;
    }

    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      registerTask.run();
    }
  };

  const formFields = () => [
    h('div', { class: columnsClass }, [
      h('div', { class: 'column' }, [inputField({
        name: 'firstName',
        label: t('common.first-name'),
        placeholder: '',
        value: userRecord.value.firstName,
        required: false,
        errors: validationErrors.value,
        disabled: registerTask.state.value.pending,
      }, v => {
        userRecord.value.firstName = v;
      })]),
      h('div', { class: 'column' }, [inputField({
        name: 'lastName',
        label: t('common.last-name'),
        placeholder: '',
        value: userRecord.value.lastName,
        required: false,
        errors: validationErrors.value,
        disabled: registerTask.state.value.pending,
      }, v => {
        userRecord.value.lastName = v;
      })]),
    ]),
    inputField({
      name: 'email',
      type: 'email',
      label: t('auth.work-email'),
      placeholder: '',
      value: userRecord.value.email,
      required: false,
      errors: validationErrors.value,
      disabled: registerTask.state.value.pending,
    }, v => {
      userRecord.value.email = v;
    }),
    phoneNumberField({
      name: 'phone',
      label: t('common.phone'),
      required: false,
      errors: validationErrors.value,
      value: userRecord.value.contactPhoneNumber,
      size: 'sm',
      noValidation: true,
      placeholder: '',
      showCodeOnList: true,
      noExample: false,
      disabled: registerTask.state.value.pending,
    }, () => {
      //do nothing
    }, (v: PhoneNumberUpdateData) => {
      //set phone number input without modifications
      userRecord.value.contactPhoneNumber = v.nationalNumber;
      userRecord.value.contactPhoneCode = v.countryCallingCode;
      userRecord.value.contactPhoneCountry = v.countryCode;
    }),
    inputField({
      name: 'password',
      type: 'password',
      label: t('auth.password'),
      placeholder: t('auth.enter-password'),
      value: userRecord.value.password,
      required: false,
      errors: validationErrors.value,
      disabled: registerTask.state.value.pending,
      tooltipText: t('dictionary.validation.strongPassword'),
    }, v => {
      userRecord.value.password = v;
    }),
    apiErrorMessage(registerTask.state.value),
  ];

  return {
    formFields,
    handleRegisterFormSubmit,
  };
}
